import { createContext } from "react";
export var LocaleContext = createContext({
    isLocaleOverlayOpened: false,
    setIsLocaleOverlayOpened: function () { return null; },
});
